var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            modal: false,
            visible: _vm.innerVisible,
            width: "295px",
            title: _vm.$t("CargoMsg.Cargo_BatchUpload"),
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: {
                    "flex-direction": "row",
                    "text-align": "center"
                  }
                },
                [
                  _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_PleaseSelectBusinessData")
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "1" },
                          model: {
                            value: _vm.pageRadio,
                            callback: function($$v) {
                              _vm.pageRadio = $$v
                            },
                            expression: "pageRadio"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "mblNo" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BlNo")))
                          ]),
                          _c("el-radio", { attrs: { label: "jobNo" } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "spacing" }),
            _c(
              "div",
              {
                staticClass: "triggers",
                staticStyle: { "text-align": "center" }
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.selectedHandler }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.confirm")) + " ")]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "3" }, on: { click: _vm.cancel } },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.cancel")) + " ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }